import React, { memo } from 'react';
import { FormattedTranscriptionType } from './transcriptions.types';
import { formatVoiceLabel, isNumeric } from './utils';

export interface TranscriptionSpeakersCellProps {
  original: FormattedTranscriptionType;
  index: number;
  speakers: { speaker: string; color: string }[] | undefined;
}

/**
 * Cell content for the speakers column: shows unique speaker labels with their assigned colors.
 */
const TranscriptionSpeakersCell = memo(
  ({ original, index, speakers }: TranscriptionSpeakersCellProps) => {
    const filteredData = original?.elastic_data?.diarization?.filter(
      (item, idx, self) => self.findIndex((obj) => obj?.voice_label === item?.voice_label) === idx,
    );

    return (
      <div key={`speaker-${index}`}>
        {filteredData?.map((data, idx) => {
          const speaker = speakers?.find(
            (item) => item.speaker === formatVoiceLabel(data?.voice_label),
          );

          return (
            <div style={{ color: speaker?.color }} key={`speaker-${speaker?.speaker}-${idx}`}>
              {speaker?.speaker
                .split(' ')
                .map((item: string) => item.charAt(0).toUpperCase() + item.slice(1))
                .filter((value: string) => !isNumeric(value))
                .join(' ')}
            </div>
          );
        })}
      </div>
    );
  },
);

TranscriptionSpeakersCell.displayName = 'TranscriptionSpeakersCell';

export default TranscriptionSpeakersCell;
